<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.state.searchCardShow"
                :gutter="16">
                <Col span="24">
                        <search-card :form="mainTable.config.searchForm"
                    :table-load-event="getInspectorUserTableRecords"
                    :table-search="mainTable.search" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">总监账号列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onEditRole">角色</Button>
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateInspectorUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.state.searchCardShow = !mainTable.state.searchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.config.columns"
                    :data="processedTableData"
                    :extHeight="60"
                    :loading="mainTable.state.loading"
                    :table-search="mainTable.search"
                    :table-load-event="getInspectorUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <InspectorUserEdit ref="inspectorUserModal" :departmentList="departmentList" />
        <RoleEdit ref="roleEdit"/>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import { dateRender } from '@/libs/tableRowTimeRender';
import InspectorUserEdit from './inspector-user-edit';
import { getInspectorUserList } from '@/api/modules/account-management/inspector-user-management';
import RoleEdit from '@/view/account-management/role-management/role-edit.vue';
export default {
    name: 'InspectorUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        InspectorUserEdit,
        RoleEdit
    },
    props: {
        departmentList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            mainTable: {
                // 配置类数据
                config: {
                    columns: [],
                    searchForm: []
                },
                // 状态类数据
                state: {
                    loading: false,
                    searchCardShow: false
                },
                // 数据类
                data: [],
                // 查询参数
                search: search.getSearchParams()
            }
        };
    },
    created() {
        // 初始化配置数据（避免在data中调用方法）
        this.initTableConfig();
    },
    computed: {
        /**
         * 表格数据（可添加额外的数据过滤或处理）
         * @returns {Array} 处理后的表格数据
         */
        processedTableData() {
            return this.mainTable.data || [];
        }
    },
    mounted() {
        this.getInspectorUserTableRecords();
    },
    methods: {
        /**
         * 初始化表格配置
         */
        initTableConfig() {
            this.mainTable.config.columns = this.getTableColumns();
            this.mainTable.config.searchForm = this.getSearchForm();
        },

        /**
         * 获取表格列配置
         * @returns {Array} 表格列配置数组
         */
        getTableColumns() {
            // 表格常量配置
            const COLUMN_WIDTH = {
                INDEX: 60,
                ACTION: 80
            };
            
            const ALIGN_CENTER = 'center';
            
            // 状态列渲染函数（避免重复创建）
            const statusRenderer = (h, params) => {
                return h('div', [
                    h('span', {}, statusFormat(params.row.userStatus))
                ]);
            };
            
            // 时间列渲染函数
            const timeRenderer = (h, params) => {
                return dateRender(h, params.row.userCreateAt);
            };
            
            // 操作列渲染函数
            const actionRenderer = (h, params) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'text',
                            size: 'small',
                            shape: 'circle'
                        },
                        style: {},
                        on: {
                            click: () => {
                                this.onUpdateInspectorUser(params.row);
                            }
                        }
                    }, '编辑')
                ]);
            };
            
            return [
                { 
                    title: '行号', 
                    type: 'index', 
                    width: COLUMN_WIDTH.INDEX, 
                    align: ALIGN_CENTER 
                },
                { 
                    title: '登录账号', 
                    key: 'userName', 
                    align: ALIGN_CENTER 
                },
                { 
                    title: '姓名', 
                    key: 'userPersonName', 
                    align: ALIGN_CENTER 
                },
                { 
                    title: '角色名称', 
                    key: 'name', 
                    align: ALIGN_CENTER 
                },
                { 
                    title: '手机号码', 
                    key: 'userPhone', 
                    align: ALIGN_CENTER 
                },
                {
                    title: '状态',
                    key: 'userStatus',
                    align: ALIGN_CENTER,
                    render: statusRenderer
                },
                { 
                    title: '创建时间', 
                    key: 'userCreateAt', 
                    align: ALIGN_CENTER, 
                    render: timeRenderer 
                },
                {
                    title: '操作',
                    key: 'action',
                    align: ALIGN_CENTER,
                    width: COLUMN_WIDTH.ACTION,
                    render: actionRenderer
                }
            ];
        },

        /**
         * 获取搜索表单配置
         * @returns {Array} 搜索表单配置数组
         */
        getSearchForm() {
            // 搜索表单常量
            const SEARCH_OPERATORS = {
                LIKE: 'like',
                IN: 'in'
            };
            
            const USER_STATUS = {
                ACTIVE: { value: 1, key: '激活' },
                FROZEN: { value: -1, key: '冻结' }
            };
            
            return [
                { 
                    label: '登陆帐号', 
                    type: 'Input', 
                    value: '', 
                    name: 'userName', 
                    sql: SEARCH_OPERATORS.LIKE 
                },
                { 
                    label: '姓名', 
                    type: 'Input', 
                    value: '', 
                    name: 'userPersonName', 
                    sql: SEARCH_OPERATORS.LIKE 
                },
                { 
                    label: '状态', 
                    type: 'Select', 
                    name: 'userStatus', 
                    sql: SEARCH_OPERATORS.IN, 
                    options: [USER_STATUS.ACTIVE, USER_STATUS.FROZEN] 
                }
            ];
        },

        /**
         * 获取总监用户表格数据
         * @param {boolean} reset - 是否重置搜索条件
         */
        async getInspectorUserTableRecords(reset = false) {
            this.mainTable.state.loading = true;

            try {
                // 重置搜索条件
                if (reset) {
                    search.globalResetSearch(this.mainTable.search);
                }
                
                // 设置用户类型
                this.mainTable.search.userType = 'J';
                
                // 调用API获取数据
                const res = await getInspectorUserList(this.mainTable.search);
                
                // 处理API响应
                if (res.code === 0) {
                    this.mainTable.data = res.data.records || [];
                    search.globalSetFilterRecordCount(this.mainTable.search, res.data.filterRecordCount || 0);
                }
                else {
                    // 业务逻辑错误处理
                    const errorMessage = res.message || '获取数据失败，请稍后重试';
                    this.$Message.error(errorMessage);
                    console.error('API Business Error:', res);
                }
            }
            catch (error) {
                // 网络错误或系统异常处理
                let errorMessage = '网络错误，请稍后重试';
                
                // 更详细的错误信息（开发环境）
                if (process.env.NODE_ENV === 'development') {
                    if (error.response) {
                        // HTTP错误响应
                        errorMessage = `请求失败 (${error.response.status}): ${
                            (error.response.data && error.response.data.message) || error.message
                        }`;
                    }
                    else if (error.request) {
                        // 请求已发送但无响应
                        errorMessage = '服务器无响应，请检查网络连接';
                    }
                    else {
                        // 其他错误
                        errorMessage = `系统错误: ${error.message}`;
                    }
                }
                
                this.$Message.error(errorMessage);
                console.error('API System Error:', error);
            }
            finally {
                // 确保loading状态正确重置
                this.mainTable.state.loading = false;
            }
        },
        /**
         * 创建总监用户
         */
        onCreateInspectorUser() {
            try {
                this.$refs.inspectorUserModal.showModal('');
            }
            catch (error) {
                this.$Message.error('打开新增窗口失败');
                console.error('Open Create Modal Error:', error);
            }
        },

        /**
         * 更新总监用户
         * @param {Object} userRow - 用户行数据
         */
        onUpdateInspectorUser(userRow) {
            try {
                if (!userRow || !userRow.userUuid) {
                    this.$Message.error('用户数据无效');
                    return;
                }
                this.$refs.inspectorUserModal.showModal(userRow.userUuid);
            }
            catch (error) {
                this.$Message.error('打开编辑窗口失败');
                console.error('Open Edit Modal Error:', error);
            }
        },
        onEditRole(){
            this.$refs.roleEdit.openRoleEditModal("总监");
        }
    }
};
</script>

<style scoped>
</style>
